export enum PublicationStatus {
  PUBLISHED = 1,
  DRAFT = 2,
}
